import { useState, useEffect } from 'react';
import { domain, token } from '../../../Security';
import axios from '../../../../api/apiClient';
import CloseIcon from '@mui/icons-material/Close';

export function AddEditFormBeneficiary({ isOpen,
  onClose,
  benefitId,
  setBenefitId,
  modalName,

  isActive, setIsActive,
  handleSubmit }) {
  const [errorState, setErrorState] = useState(false);

  const submit = (e) => {
    if (!benefitId) {
      setErrorState(true);
      return;
    }
    handleSubmit(e);
    setErrorState(false);
    handleClose();
  };

  const handleClose = () => {
    onClose();
    setBenefitId("");
    setIsActive(false)
    setErrorState(false);
  };

  return (
    <>
      <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>{modalName}</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div className="popUp-body">
              <div className="popUp-item info-item column">
                <div className="info-item-label">Benefit</div>
                <div className="info-item-input">
                  <BenefitIdSelect benefitId={benefitId} setBenefitId={setBenefitId} />
                </div>
                <span style={{
                  visibility: !benefitId && errorState ? "visible" : "hidden",
                  color: "#ff6565",
                  fontSize: "12px"
                }}>Please fill up this field
                </span>
              </div>
              <div className="popUp-item info-item row" style={{ alignItems: "center" }}>
                <div className="info-item-label" style={{ paddingRight: "10px" }}>Is Active?</div>
                <div className="info-item-input">
                  <input type="checkbox"
                    id="isActive-checkbox"
                    className="checkbox"
                    name=""
                    checked={isActive}
                    onChange={(event) => setIsActive(event.target.checked)} />
                </div>
              </div>
            </div>
            <div className="buttons row" style={{ justifyContent: "end", padding: "20px 40px" }}>
              <button id="add-family"
                className="save row"
                onClick={(e) => submit(e)}>
                SAVE
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
export function DeleteForm({ isOpen,
  onClose,
  handleDelete }
) {
  const handleSubmit = () => {
    handleDelete()
    handleClose()
  }
  const handleClose = () => {
    onClose();
  };

  return (
    <>
      <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>Delete!</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div className="popUp-body" style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
              <span>Are you sure you want to delete this employee?</span>
            </div>
            <div className="buttons row" style={{ justifyContent: "center", padding: "40px 40px 20px 40px" }}>
              <button id="add-family"
                className="save row"
                onClick={handleSubmit}
                style={{ marginRight: "5px" }}>
                DELETE
              </button>
              <button id="add-family"
                className="cancel row"
                onClick={() => handleClose()}>
                CANCEL
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

function SetBenefitId(benefitId){
    return(
        <option id={"leaveType" + benefitId.id} value={benefitId.id}>{
            benefitId.name}
        </option>
    )
    
}

function BenefitIdSelect({ benefitId, setBenefitId }) {
  const [isSelected, setIsSelected] = useState(false);

  const handleSelectChange = (event) => {
    setIsSelected(true);
    setBenefitId(event.target.value);
  };

  const [benefitIds, setBenefitIds] = useState([]);

  const fetchData = async () => {
    const apiUrl = domain + "/api/Benefit/active";

    await axios.get(apiUrl, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json' // You can include other headers if needed
      }
    })
      .then(response => {
        setBenefitIds(response.data); // Set the response data to the state
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      });
  }

  useEffect(() => {
    fetchData();
    if (benefitId !== "" && benefitId !== 0) {
      setIsSelected(true);
    } else {
      setIsSelected(false);
    }
  }, [benefitId]);

  return (
    <div>
      <select id="employee-select-PagibigReport" value={benefitId} onChange={handleSelectChange} style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
        <option value="" disabled hidden>Choose benefit</option>
        {benefitIds.map((benefitId) => (
          SetBenefitId(benefitId)
        ))}
      </select>
    </div>
  );
};